import { render } from "./LoginComp.vue?vue&type=template&id=a68c2ec2&scoped=true"
import script from "./LoginComp.vue?vue&type=script&lang=js"
export * from "./LoginComp.vue?vue&type=script&lang=js"

import "./LoginComp.vue?vue&type=style&index=0&id=a68c2ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68c2ec2"]])

export default __exports__